import { observer } from "mobx-react";
import FontBody3 from "../../../components/fonts/font-body3/font-body3";
import FontBody1 from "../../fonts/font-body1/font-body1";
import ShopsSelectorStore from "../shops-selector-store";
import FontBody4 from "../../fonts/font-body4/font-body4";

interface ISelectDropdownProps {
    store: ShopsSelectorStore;
}

const ShopSelectorInput: React.FC<ISelectDropdownProps> = observer(({ store }) => {
    const fetchedShops =  store.fetchedShops;

    if (!fetchedShops.length) {
        return null;
    }

    return (
        <div className="shops-select-dropdown">
            {
                fetchedShops.map(shop => {
                    return (
                        <div
                            className="shops-select-dropdown-item"
                            onClick={(shop.isSelectable) ? () => store.select(shop) : undefined}
                            key={shop.id}
                        >
                            <FontBody1>{shop.name}</FontBody1> <FontBody4>{shop.id}</FontBody4>
                            {shop.tag && <FontBody3> {shop.tag}</FontBody3>}
                        </div>
                    );
                })
            }
        </div>
    );
});

export default ShopSelectorInput;
